import React from "react";
import Main from "./Main";
import Profile from "./Profile";
import Interests from "../components/Interests";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="">
      <Main />
      <Profile />
      <div className="sm:flex sm:justify-between bg-slate-100 dark:bg-slate-900 dark:text-white m-5 p-3 rounded-2xl">
        <div className="px-4 py-2 rounded-lg font-bold sm:text-lg cursor-pointer">
          <Link to="/education">Education</Link>
        </div>
        <div className="px-4 py-2 rounded-lg font-bold sm:text-lg cursor-pointer">
          <Link to="/experience">Experience</Link>
        </div>
        <div className="px-4 py-2 rounded-lg font-bold sm:text-lg cursor-pointer">
          <Link to="/projects">Projects</Link>
        </div>
        <div className="px-4 py-2 rounded-lg font-bold sm:text-lg cursor-pointer">
          <Link to="/skills">Skills</Link>
        </div>
        <div className="px-4 py-2 rounded-lg font-bold sm:text-lg cursor-pointer">
          <Link to="/certificates">Certificates</Link>
        </div>
      </div>
      <Interests />
    </div>
  );
};

export default Home;
